export default "https://cdn-static.gokick.com/assets/2b3e6896c425e2cf7d1a83db5abe7919e5484d77/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";